<template>
    <div>
        <div class="input-group color-picker" ref="colorpicker">
            <div class="input-group-prepend">
                <base-input
                    type="text"
                    v-model="colorValue"
                    @focus="$_togglePicker()"
                    @input="$_updateFromInput"
                >
                </base-input>
                <span class="input-group-prepend">
                    <span
                        class="input-group-text"
                        :style="'background-color: ' + colorValue"
                        @click="$_togglePicker()"
                    ></span>
                    <chrome-picker
                        :value="colors"
                        :disableAlpha="disableAlpha"
                        :disableFields="disableFields"
                        @input="$_updateFromPicker"
                        v-if="displayPicker"
                    />
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import chrome from 'vue-color/src/components/Chrome.vue';
    import baseInput from './BaseComponents/base-input.vue';
    import { convertHexToRgbAValue } from './../services/utilities';

    export default {
        name: 'color-picker',

        components: {
            'chrome-picker': chrome,
            'base-input': baseInput
        },

        props: {
            value: { type: String, default: 'rgba(00,00,00,1)' },
            disableAlpha: {
                type: Boolean,
                default: false
            },
            disableFields: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                displayPicker: false,
                colorValue: '',
                colors: {}
            };
        },

        mounted() {
            this.$_setColor(this.value || 'rgba(00,00,00,1)');
        },

        methods: {
            $_documentClick(e) {
                const el = this.$refs.colorpicker;
                const target = e.target;
                if (el && el !== target && !el.contains(target)) {
                    this.$_hidePicker();
                }
            },

            $_hidePicker() {
                document.removeEventListener('click', this.$_documentClick);
                this.displayPicker = false;
            },

            $_setColor(color) {
                this.$_updateColors(color);
                this.colorValue = color;
            },

            $_showPicker() {
                document.addEventListener('click', this.$_documentClick);
                this.displayPicker = true;
            },

            $_togglePicker() {
                this.displayPicker ? this.$_hidePicker() : this.$_showPicker();
            },

            $_updateColors(color) {
                if (color.slice(0, 1) === '#') {
                    this.colors = convertHexToRgbAValue(color);
                } else if (color.slice(0, 4) === 'rgba') {
                    this.colors = color;
                }
            },

            $_updateFromInput() {
                this.$_updateColors(this.colorValue);
            },

            $_updateFromPicker(color) {
                this.colors = color;
                this.colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
            }
        },

        watch: {
            colorValue(val) {
                this.$_updateColors(val);
                this.$emit('input', val);
            }
        }
    };
</script>

<style>
.color-picker .vc-chrome {
    position: absolute;
    top: 38px;
    right: 0;
    z-index: 9;
}

.color-picker .vc-chrome,
.color-picker .vc-chrome-body {
    border-radius: 4px;
}

.color-picker .vc-chrome-fields .vc-input__input {
    height: 32px;
    border-radius: 6px;
}

.color-picker .vc-chrome-toggle-btn {
    width: initial;
}

.color-picker .vc-chrome-toggle-icon {
    margin-top: 4px;
}

.color-picker .vc-chrome-toggle-icon-highlight {
    top: 2px;
    left: initial;
}
</style>

<style scoped>
.current-color {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: #000;
    cursor: pointer;
}
</style>
